import { createAsyncThunk } from '@reduxjs/toolkit';
import { StatusCodes } from 'http-status-codes';
import { adminAPI } from '../../api/services/userApi';
import { errorReturn } from '../../utils/errorReturnHelper';
import { setLoading, unsetLoading } from './whitelabelSlice';

const getSkiptraceStats = createAsyncThunk(
  'skiptraceStats/get',
  async (
    payload: { accountId: string; startDate?: Date | null; endDate?: Date | null },
    { rejectWithValue, dispatch },
  ) => {
    try {
      dispatch(setLoading());
      const res = await adminAPI.getSkiptraceStats(payload.accountId, {
        startDate: payload.startDate,
        endDate: payload.endDate,
      });
      if (res.status === StatusCodes.OK) {
        return res.data.data;
      }
    } catch (err) {
      return rejectWithValue(errorReturn(err));
    } finally {
      dispatch(unsetLoading());
    }
  },
);

const getUserStats = createAsyncThunk(
  'userStats/get',
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setLoading());
      const res = await adminAPI.getUserStats(id);
      if (res.status === StatusCodes.OK) {
        return res.data.data;
      }
    } catch (err) {
      return rejectWithValue(errorReturn(err));
    } finally {
      dispatch(unsetLoading());
    }
  },
);

export default {
  getSkiptraceStats,
  getUserStats,
};
